import { Base64 } from 'js-base64'
import Bridge from 'src/frontend-lib/lib/Bridge'

export default {
  methods: {
    // 修复bug #7482 ref替换为source 考虑后面改版可能又会大批量修改，还是放在同个文件好了
    mixinToTeacherPage(userId, ref = '', channelId = '') {
      const url = `${window.location.protocol}${
        this.mobileSite
      }expert/${userId}?source=${Base64.encodeURI(ref)}&cid=${channelId}`
      if (this.platform.isYixinliApp || this.platform.isZiXunApp) {
        const bridge = new Bridge()
        bridge.call('openWebView', {
          url,
          isCurrentPageOpen: 0,
          hideNavigationBar: 1
        })
      } else {
        window.location.href = url
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/consult/link.js